import { memo, useEffect } from 'react';
import { styled } from '@mui/material';
import Section1 from './Section1';
import Section2 from './Section2';
import Section3 from './Section3';

const HeroSection = styled('section')(({ theme }) => ({
  background: 'url("https://bucket.ywhdev.com/wl/?id=RVGv8MD0LYAHpMS0ingzCucXdPpmlYdq&fmode=open")',
  overflow: 'hidden',
  height: 700,
  [theme.breakpoints.down('sm')]: {
    height: 450,
  },
  alignItems: 'flex-end',
  display: 'flex',
  justifyContent: 'center',
  paddingBottom: 80,
  position: 'relative',
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  borderBottom: '8px solid #5284e0',
  gap: 8,
  textAlign: 'center',
  '& div.header': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    h1: {
      color: 'white',
      fontFamily: 'Playfair Display',
      zIndex: 2,
      fontSize: 48,
      lineHeight: '60px',
      fontWeight: 700,
    },
    h3: {
      color: '#CDA07D',
      zIndex: 2,
      fontSize: 24,
      lineHeight: '36px',
      fontWeight: 600,
    },
    img: {
      width: '100%',
      bottom: 0,
      position: 'absolute',
    },
  },
}));

const Content = styled('section')(({ theme }) => ({
  padding: '100px 0',
  [theme.breakpoints.down('md')]: {
    padding: '0',
  },
}));

const ClosingCost = () => {
  useEffect(() => {}, []);

  return (
    <>
      <HeroSection>
        <div className="header">
          <h1>What are Closing Costs</h1>
          <h3>Take a deeper look at some common closing fees</h3>
        </div>
      </HeroSection>
      <Content>
        <Section1 />
        <Section2 />
        <Section3 />
      </Content>
    </>
  );
};

export default memo(ClosingCost);
